import classNames from 'classnames';
import React from 'react';

import css from './IconDownload.module.css';

const IconDownload = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="16"
      height="16"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27 19.998a1 1 0 0 1 .993.884L28 21l-.002 5a2 2 0 0 1-1.85 1.993l-.15.006H2a2 2 0 0 1-1.995-1.85L0 26v-5.002a1 1 0 0 1 1.993-.116l.007.116V26h23.998L26 20.998a1 1 0 0 1 1-1M14.001 0a1 1 0 0 1 .993.883l.007.117v16.584l6.292-6.292a1 1 0 0 1 1.492 1.327l-.078.087-7.999 8a1 1 0 0 1-.085.076l-.009.007-.028.02a1 1 0 0 1-.075.05l-.026.014-.08.04-.038.016-.051.019-.018.005a1 1 0 0 1-.124.03l-.027.005a1 1 0 0 1-.146.01h-.033l-.052-.003.085.003a1 1 0 0 1-.182-.016l-.023-.005a1 1 0 0 1-.09-.023h-.003l-.015-.006a1 1 0 0 1-.094-.036l-.003-.002-.018-.008-.046-.023-.035-.02-.004-.002-.005-.003-.01-.006a1 1 0 0 1-.179-.142l-8-8a1 1 0 0 1 1.328-1.492l.087.078L13 17.584V1a1 1 0 0 1 1-1" />
    </svg>
  );
};

export default IconDownload;
